export default __webpack_public_path__ + "static/media/Category.d046d897.svg";